function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgManufacturing = function SvgManufacturing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 482 482",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Capa_1_1565755547656",
    width: 70,
    height: 67,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.056,209.104c-2.442-1.434-5.46-1.471-7.936-0.096l-22.016,12.232L424,7.776c-0.121-4.331-3.668-7.778-8-7.776h-56    c-4.332-0.002-7.879,3.445-8,7.776L344.544,268.8L320,282.4V216c-0.002-4.418-3.586-7.998-8.004-7.996    c-1.356,0.001-2.69,0.346-3.876,1.004L176,282.4V216c-0.002-4.418-3.586-7.998-8.004-7.996c-1.356,0.001-2.69,0.346-3.876,1.004    l-144,80c-2.541,1.409-4.119,4.086-4.12,6.992v176c0,4.418,3.582,8,8,8h432c4.418,0,8-3.582,8-8V216    C464,213.165,462.5,210.541,460.056,209.104z M367.776,16h40.448l0.464,16H367.32L367.776,16z M366.856,48h42.288l5.2,181.992    L360.8,259.728L366.856,48z M232,464h-48v-40h48V464z M296,464h-48v-40h48V464z M448,464H312v-48c0-4.418-3.582-8-8-8H176    c-4.418,0-8,3.582-8,8v48H32V300.712L160,229.6V296c0.002,4.418,3.586,7.998,8.004,7.996c1.356-0.001,2.69-0.346,3.876-1.004    L304,229.6V296c0.002,4.418,3.586,7.998,8.004,7.996c1.356-0.001,2.69-0.346,3.876-1.004l75.448-41.912L426.4,241.6l21.6-12V464z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128,320H64c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32C136,323.582,132.418,320,128,320z     M120,352H72v-16h48V352z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M272,320h-64c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32C280,323.582,276.418,320,272,320z     M264,352h-48v-16h48V352z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416,320h-64c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32C424,323.582,420.418,320,416,320z     M408,352h-48v-16h48V352z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManufacturing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manufacturing.80352920.svg";
export { ForwardRef as ReactComponent };